import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { TitreDescription } from '@components/titre-description/models';
import { TitleDescriptionComponent } from '@shared/components/title-description';

@Component({
  selector: 'app-titre-description',
  imports: [TitleDescriptionComponent],
  templateUrl: './titre-description.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitreDescriptionComponent extends AbstractDynamicComponent<TitreDescription> {}
